export const SET_COUNTRY_CONFIG = 'SET_COUNTRY_CONFIG';
export const setCountryConfig = (countryConfig) => ({
  type: SET_COUNTRY_CONFIG,
  countryConfig,
});
